import { BatchMultipleUnderlyingsWrapper } from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/BatchMultipleUnderlyingsField';
import { useMultipleApplyBatchUnderlyingsSearch } from 'components/common-form/builder/form/node/field/MultipleApply/hooks';
import { UnderlyingsResult } from 'components/common-form/builder/form/node/field/MultipleApply/UnderlyingResults';
import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { useUpdateAction } from 'components/common-form/hooks/useUpdateAction';
import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';

export function MultipleApplyBatchMultipleUnderlyingsField({ ...props }: ProductNodeBuilderProps) {
  const [updateAction, setUpdateAction] = useUpdateAction(props.node.id);

  const { getOptionsFromPastedLabels, search } = useMultipleApplyBatchUnderlyingsSearch(props.tabId, props.node.id);

  return (
    <BlockOrientationFormGroup
      inputId={props.node.id}
      workspaceType="newBatch"
      contentPosition="bottom"
      updateActions={
        <ButtonsGroup
          className="w-100 justify-content-end d-flex"
          items={['add', 'replace']}
          translationPrefix={props.node.id}
          selectedItems={[updateAction]}
          onSelect={items => setUpdateAction(items[0])}
          hasRadioStyle={true}
          isDisabled={false}
          isRadio
        />
      }
    >
      <BatchMultipleUnderlyingsWrapper
        getOptionsFromPastedLabels={getOptionsFromPastedLabels}
        search={search}
        {...props}
        useOrientation={false}
        ResultsComponent={UnderlyingsResult}
      />
    </BlockOrientationFormGroup>
  );
}
